import $ from 'jquery';
import { getState } from '~src/state';
import { isFeatureEnabled, FEATURES } from '~src/features';
import { DEFAULT_SETTINGS } from './constants';
import { saveSettings } from './saveSettings';

export async function openSettingsModal() {
  const settings = getState('settings') || DEFAULT_SETTINGS;

  // Check if spellcheck feature is enabled
  const spellCheckFeatureEnabled = await isFeatureEnabled(FEATURES.SPELLCHECK);

  // Handle spell check section visibility
  const spellCheckSection = document.getElementById('spellCheckSection');
  if (spellCheckSection) {
    if (!spellCheckFeatureEnabled) {
      // Hide spell check section if feature is disabled
      spellCheckSection.style.display = 'none';
    } else {
      // Show spell check section and set toggle
      spellCheckSection.style.display = 'block';
      const spellCheckToggle = document.getElementById('spellCheckerToggle');
      if (spellCheckToggle) {
        spellCheckToggle.checked = settings.spellCheckEnabled;
      }
    }
  }

  // Initialize alignment and snapping toggles
  const alignmentLinesToggle = document.getElementById('alignmentLinesToggle');
  if (alignmentLinesToggle) {
    alignmentLinesToggle.checked = settings.alignmentLinesEnabled;
  }

  const canvasAlignmentToggle = document.getElementById(
    'canvasAlignmentToggle'
  );
  if (canvasAlignmentToggle) {
    canvasAlignmentToggle.checked =
      settings.canvasAlignmentLinesEnabled !== false;
    // Show/hide based on main toggle
    canvasAlignmentToggle.closest(
      '.form-group'
    ).style.display = settings.alignmentLinesEnabled ? 'block' : 'none';
  }

  const objectAlignmentToggle = document.getElementById(
    'objectAlignmentToggle'
  );
  if (objectAlignmentToggle) {
    objectAlignmentToggle.checked =
      settings.objectAlignmentLinesEnabled !== false;
    // Show/hide based on main toggle
    objectAlignmentToggle.closest(
      '.form-group'
    ).style.display = settings.alignmentLinesEnabled ? 'block' : 'none';
  }

  const distanceMeasurementsToggle = document.getElementById(
    'distanceMeasurementsToggle'
  );
  if (distanceMeasurementsToggle) {
    distanceMeasurementsToggle.checked = settings.showDistanceMeasurements;
  }

  // Add event listener to show/hide sub-toggles when main toggle changes
  if (alignmentLinesToggle) {
    alignmentLinesToggle.addEventListener('change', function () {
      const displayValue = this.checked ? 'block' : 'none';
      if (canvasAlignmentToggle) {
        canvasAlignmentToggle.closest(
          '.form-group'
        ).style.display = displayValue;
      }
      if (objectAlignmentToggle) {
        objectAlignmentToggle.closest(
          '.form-group'
        ).style.display = displayValue;
      }
    });
  }

  const snappingToggle = document.getElementById('snappingToggle');
  if (snappingToggle) {
    snappingToggle.checked = settings.snappingEnabled;
  }

  // Show modal
  $('#modalEditorSettings').modal('show');

  // Initialize tooltips
  $('#modalEditorSettings [data-toggle="tooltip"]').tooltip();
}

export function initSettingsModal() {
  // Open modal when settings button is clicked
  const settingsButton = document.getElementById('btn-sidebar-settings');
  if (settingsButton) {
    settingsButton.addEventListener('click', async () => {
      await openSettingsModal();
    });
  }

  // Save settings button
  const saveButton = document.getElementById('saveSettings');
  if (saveButton) {
    saveButton.addEventListener('click', saveSettings);
  }

  // Track modal close without save
  $('#modalEditorSettings').on('hidden.bs.modal', function () {
    // Reset the saved flag
    $(this).data('saved', false);
  });
}
